import React from 'react';
import { promises, business, whyImage } from '../mock';
import { ShieldCheck, Clock, ArrowRight, Leaf } from 'lucide-react';
import BotanicalDecor from './BotanicalDecor';

export default function WhyChooseUs({ onSchedule }) {
  const cards = promises.slice(0, 4);

  return (
    <section className="section relative overflow-hidden" style={{ backgroundColor: 'var(--cream-2)' }}>
      <BotanicalDecor style={{ top: 60, right: -40, width: 170, height: 400 }} flip />
      <div className="container-x relative" style={{ zIndex: 1 }}>
        <div className="text-center max-w-[700px] mx-auto reveal">
          <p className="eyebrow mb-2">Why Choose Us</p>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>Your trust is earned &mdash; never assumed</h2>
          <p className="mt-5" style={{ color: 'var(--muted)' }}>
            Choosing care for a loved one is never easy. We make it easier by leading with honesty,
            safety, and genuine compassion, every single day.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid lg:grid-cols-3 gap-5 mt-14">
          {/* Tall image tile */}
          <div className="lg:row-span-2 rounded-[28px] overflow-hidden relative min-h-[420px] reveal">
            <img src={whyImage} alt="A senior enjoying joyful time at home with loved ones" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(20,42,31,0) 40%, rgba(20,42,31,0.82) 100%)' }} />
            <Leaf size={30} className="absolute top-6 left-6" style={{ color: 'rgba(255,255,255,0.85)' }} />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="text-white/70 text-sm mb-1">Life at home</div>
              <div className="font-serif-display text-2xl text-white" style={{ color: '#fff' }}>Joyful living, every single day</div>
            </div>
          </div>

          {/* Feature cards */}
          {cards.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="reveal p-7 rounded-[28px] bg-white transition-all duration-300 hover:-translate-y-1"
                style={{ border: '1px solid var(--line)' }}
              >
                <span className="flex items-center justify-center rounded-2xl mb-5" style={{ width: 52, height: 52, backgroundColor: 'var(--sage-soft)' }}>
                  <Icon size={26} style={{ color: 'var(--forest)' }} />
                </span>
                <h3 className="text-lg">{p.title}</h3>
                <p className="mt-2 text-[15px]" style={{ color: 'var(--muted)' }}>{p.desc}</p>
              </div>
            );
          })}

          {/* Wide 24/7 highlight */}
          <div
            className="lg:col-span-3 rounded-[28px] p-8 lg:p-10 relative overflow-hidden reveal flex flex-col sm:flex-row sm:items-center gap-6 justify-between"
            style={{ backgroundColor: 'var(--forest)' }}
          >
            <div className="flex items-start gap-4">
              <span className="flex items-center justify-center rounded-2xl shrink-0" style={{ width: 56, height: 56, backgroundColor: 'var(--sage)' }}>
                <Clock size={28} style={{ color: 'var(--forest)' }} />
              </span>
              <div>
                <h3 className="text-white text-xl" style={{ color: '#fff' }}>Around-the-clock support, whenever you need it</h3>
                <p className="text-white/70 text-[15px] mt-1.5">
                  Licensed, bonded &amp; insured &mdash; serving DFW families since {business.since}.
                </p>
              </div>
            </div>
            <button className="btn-sage shrink-0" onClick={onSchedule}>
              Talk With Us <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
